import * as sx from "./slider-thumb.sx";

export const SliderThumb = ({
  children,
  ...props
}: React.HTMLAttributes<HTMLSpanElement>) => {
  return (
    <sx.SliderThumb data-testid="slider-thumb" {...props} tabIndex={-1}>
      {/* Value Labels are passed in as children by MUI */}
      {children}
      <span className="dot" />
      <span className="dot" />
      <span className="dot" />
    </sx.SliderThumb>
  );
};
